/* eslint-disable no-case-declarations */
import {
  IRequestCardInfo,
  IRequestInfoParams,
} from '@/models/request';

const AppointmentInfo = (item: IRequestInfoParams, t: any) => {
  const val: IRequestCardInfo = {
    state: '',
    message: '',
    style: '',
    buttons: [] as Array<any>,
  };
 
  if(item.AppointmentType === 1) {
    val.state = t("appointmentTypes.appointment");
    val.style = "-royalBlue appointment type1";
  } 
  else if(item.AppointmentType === 2) {
    val.state = t("appointmentTypes.telemedicine");
    val.style = "-royalBlue appointment type2";
  } 
  
  return val;
};

export default AppointmentInfo;
